import { MsalProvider } from '@azure/msal-react'
import SilentMicrosoftLogin from './MicrosoftLogin/SilentMicrosoftLogin'
import { msalInstance } from './MicrosoftLogin/MSALConfig'

const MicrosoftLoginPage: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <MsalProvider instance={msalInstance}>
        <SilentMicrosoftLogin />
      </MsalProvider>
    </div>
  )
}

export default MicrosoftLoginPage
